import React from 'react';

const Home = React.lazy(() => import('src/shared_modules/veu-visitors-core/components/home'));
const Preregister = React.lazy(() => import('src/shared_modules/veu-visitors-core/components/preregister'));
const Scene = React.lazy(() => import('src/shared_modules/veu-visitors-core/components/scene'));
const Stream = React.lazy(() => import('src/shared_modules/veu-visitors-core/components/stream'));
const Stageview = React.lazy(() => import('src/shared_modules/veu-visitors-core/components/stageview'));
const Exhibitpano = React.lazy(() => import('src/shared_modules/veu-visitors-core/components/stageview/exhibitpano.js'));
const Player = React.lazy(() => import('src/shared_modules/veu-visitors-core/components/player'));
const Tilesmenu = React.lazy(() => import('src/shared_modules/veu-visitors-core/components/minievent'));


const ROUTE_HOME = {
    component: Home,
    path: '/:event/home',
    exact: false,
};

const ROUTE_PREREGISTER = {
    component: Preregister,
    path: '/:event/preregister',
    exact: false,
};

const ROUTE_SCENE = {
    component: Scene,
    path: '/:event/scene/:sceneId',
    exact: false,
};

const ROUTE_STREAMID = {
    component: Stream,
    path: '/:event/stream/:id',
    exact: false,
};

const ROUTE_STREAM = {
    component: Stream,
    path: '/:event/stream/',
    exact: false,
};

const ROUTE_STAGEVIEW = {
    component: Stageview,
    path: '/:event/stageview/',
    exact: false,
};

const ROUTE_EXHIBITID = {
    component: Exhibitpano,
    path: '/:event/exhibit/:id',
    exact: false,
};

const ROUTE_PLAYERID = {
    component: Player,
    path: '/:event/player/:id',
    exact: false,
};

const ROUTE_PLAYER = {
    component: Player,
    path: '/:event/player/',
    exact: false,
};

const ROUTE_MINIEVENT_TILESMENU = {
    component: Tilesmenu,
    path: '/:event/tilesmenu',
    exact: false,
};

const APP_CORE_ROUTES = [
    ROUTE_HOME,
    ROUTE_PREREGISTER,
    ROUTE_SCENE,
    ROUTE_STREAMID,
    ROUTE_STREAM,
    ROUTE_STAGEVIEW,
    ROUTE_EXHIBITID,
    ROUTE_PLAYERID,
    ROUTE_PLAYER,
    ROUTE_MINIEVENT_TILESMENU,
];

/*
* ---------------------------------------------------------------------
* Export
* ---------------------------------------------------------------------
*/
export default APP_CORE_ROUTES;
